export enum ThemeName {
  Starboard = 'starboard',
}
